import React from 'react'
import moduleName from '../components/PageBuilder/PageBuilder'
import styled from 'styled-components'
import { Navigate, useLocation } from 'react-router-dom';
import PageLayout from '../components/Layouts/PageLayout';
import PageBuilder from '../components/PageBuilder/PageBuilder';
import { MainData } from '../Data/MainData';
import { getLanLoc } from '../components/Functions/LangFunc';

const Styles = styled.div`
    display: flex;
    flex-direction: column;
`

function VisaLanding(props) {
    const location = useLocation();
    let {isEn: lan, isSet: isSetLan} = getLanLoc(location.pathname);
    if(!isSetLan){
    return (
        <Navigate replace={true} to={"/en/visa_landing" + location.pathname}/>
    )
    }
    return (
        <PageLayout
          {...props} 
          language={lan ? {...MainData.dict[0]} : {...MainData.dict[1]}} 
          dict={MainData.dict} 
          mainLogo={MainData.mainLogo} 
          texts={MainData.texts} 
          nav={MainData.nav} 
          footer={MainData.footer} 
          login={MainData.login}
        >
          <Styles>
            <PageBuilder lan={(lan ? MainData.dict[0] : MainData.dict[1])} page={"visa_landing_" + (lan ? MainData.dict[0].filename : MainData.dict[1].filename)}/>
          </Styles>
        </PageLayout>
  )
}

export default VisaLanding
